<!--
  NylonCollapse — animated show/hide region.

  Collapses its slot content by transitioning `grid-template-rows: 1fr → 0fr`
  on the wrapper, which clips content from the bottom edge instead of
  squishing it — no max-height guesses, any content height, animates both
  directions. Content stays mounted throughout, so inner component state
  (dropzones, inputs) survives collapse.

  The inner region only clips (`overflow: hidden`) while collapsed or
  mid-transition, so anything that intentionally overflows an expanded
  region is unaffected at rest.

  Props:
    collapsed (boolean, required)
      Collapse state, owned by the caller.
-->
<template>
  <div class="nylon-Collapse" :class="{ 'is-collapsed': collapsed, 'is-clipping': collapsed || isAnimating }" @transitionend.self="onTransitionEnd">
    <div class="nylon-Collapse-inner">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "NylonCollapse",

  props: {
    collapsed: { type: Boolean, required: true },
  },

  data() {
    return {
      isAnimating: false,
    };
  },

  watch: {
    collapsed() {
      this.isAnimating = true;
    },
  },

  methods: {
    onTransitionEnd(event) {
      if (event.propertyName === "grid-template-rows") {
        this.isAnimating = false;
      }
    },
  },
};
</script>
